import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DashboardsModule } from '../dashboards/dashboards.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [HomeComponent],
  imports: [CommonModule, HomeRoutingModule, DashboardsModule]
})
export class HomeModule {}
